<div class="flex h-full w-full flex-col pb-4">
  <h2 class="py-4 text-center text-lg font-medium">Observations Over Time</h2>
  <div
    class="flex min-h-0 flex-1 items-center justify-center"
    role="img"
    aria-label="Line chart showing observation trends over time by severity level"
  >
    <apx-chart
      class="block h-full w-full"
      [series]="chartOptions().series"
      [chart]="chartOptions().chart"
      [xaxis]="chartOptions().xaxis"
      [yaxis]="chartOptions().yaxis"
      [stroke]="chartOptions().stroke"
      [title]="chartOptions().title"
      [grid]="chartOptions().grid"
      [dataLabels]="chartOptions().dataLabels"
      [tooltip]="chartOptions().tooltip"
      [colors]="chartOptions().colors"
      [legend]="chartOptions().legend"
    />
  </div>
</div>
